import { supabase } from '../../lib/supabaseClient.js';
import { useState, useEffect } from 'react';
import './ClubApplyForm.css'

// 동아리 지원 신청 폼 컴포넌트
export default function ClubApplyForm({ club, onClose }){
    // 지원서 입력 정보 저장
    const [join, setJoin] = useState({
       name: '',
       department: '',
       stunum:'',
       grade:'',
       phone:'',
       gender:'',
       activity:'',
    });

    // 컴포넌트 실행 시 로그인한 사용자 정보 조회
    useEffect(() => {
        getUserInfo();
    }, []);

    // 로그인한 사용자의 기본 정보를 불러와 신청 폼에 자동 입력
    async function getUserInfo() {
    const { data: { user } } = await supabase.auth.getUser();
    if (!user) return;

    const { data, error } = await supabase
        .from('users')
        .select('name, department, student_number, grade, phone, gender')
        .eq('email', user.email)
        .maybeSingle();

    if (error) { console.log(error); return; }
    if (!data) return;

    setJoin({
        name: data.name || '',
        department: data.department || '',
        stunum: data.student_number || '',
        grade: data.grade || '',
        phone: data.phone || '',
        gender: data.gender || '',
        activity: '',
    });
    }

    // 입력값 변경 시 상태 업데이트
    function handleChange(e) {
        const { name, value } = e.target;

        setJoin({
            ...join,
            [name]: value,
        });
    }

    // 동아리 지원 신청 처리
    async function handleSubmit() {
    const { data: { user } } = await supabase.auth.getUser();
    if (!user) { alert('로그인을 해주세요!'); return; }

    // users 테이블에서 실제 id 조회
    const { data: userData } = await supabase
        .from('users')
        .select('id')
        .eq('email', user.email)
        .maybeSingle();

    if (!userData) { alert('사용자 정보를 찾을 수 없습니다.'); return; }

    // 지원서 정보를 club_applications 테이블에 저장
    const { error } = await supabase
        .from('club_applications')
        .insert([{
            club_id: club.id,
            user_id: userData.id,  // users 테이블의 id 사용
            name: join.name,
            department: join.department,
            student_number: join.stunum,
            grade: Number(join.grade),
            phone: join.phone,
            gender: join.gender,
            desired_activity: join.activity,
        }]);

    if (error) { console.log(error); alert("지원 실패"); return; }

    alert("지원 성공");
    onClose();
}

    return(
        <div className="ClubApplyForm-bg">
            <div className="ClubApplyForm">
                {/* 지원할 동아리명 표시 */}
                <h2>동아리 명: {club.name}</h2>

                {/* 이름 입력 */}
                <div className="apply-row apply-info-row">
                    <label>이름 :</label>
                    <input name="name" value={join.name} onChange={handleChange} />
                </div>

                {/* 학과 입력 */}
                <div className="apply-row apply-info-row">
                    <label>학과 :</label>
                    <input name="department" value={join.department} onChange={handleChange} />
                </div>

                {/* 학번 입력 */}
                <div className="apply-row apply-info-row">
                    <label>학번 :</label>
                    <input name="stunum" value={join.stunum} onChange={handleChange} />
                </div>

                {/* 학년 입력 */}
                <div className="apply-row apply-info-row">
                    <label>학년 :</label>
                    <input name="grade" value={join.grade} placeholder='x학년' onChange={handleChange} />
                </div>

                {/* 연락처 입력 */}
                <div className="apply-row apply-info-row">
                    <label>연락처 :</label>
                    <input name="phone" value={join.phone} placeholder='010-xxxx-xxxx' onChange={handleChange} />
                </div>

                {/* 성별 선택 */}
                <div className="apply-row apply-info-row">
                    <span>성별 :</span>
                    <label><input type="radio" name="gender" value="남자" checked={join.gender === '남자'} onChange={handleChange} />남자</label>
                    <label><input type="radio" name="gender" value="여자" checked={join.gender === '여자'} onChange={handleChange} />여자</label>
                </div>

                {/* 희망 활동 입력 */}
                <div className="apply-row">
                    <label>해보고 싶은 활동 :</label>
                    <textarea name="activity" value={join.activity} onChange={handleChange} />
                </div>

                {/* 신청 버튼 */}
                <button onClick={handleSubmit}>신청하기</button>

                {/* 폼 닫기 버튼 */}
                <button className="ClubApplyForm-close" onClick={onClose}>X</button>
            </div>
        </div>
    );
}